<template>
    <div>
        <rkm-form
            ref="Form"
            show-legend
        >
            <rkm-row>

                <rkm-col cols="12">
                    <rkm-area
                        title="Condições de Moradia"
                        type="fieldset"
                        no-margin-top
                    >

                        <rkm-row>

                            <rkm-col cols="6">
                                <rkm-form-select
                                    :disabled="model.foraArea"
                                    :options="form.microareas"
                                    label="Área/Microárea do domicílio"
                                    show-default-option
                                    text-field="descricao"
                                    v-model="model.microareaId"
                                    default-option-text="Selecione"
                                    value-field="id"
                                    class="pt-0"
                                    :validations="validations.microareas"
                                >
                                    <rkm-input-group-append slot="append">
                                        <rkm-input-group-text>
                                            <rkm-form-checkbox
                                                v-model="model.foraArea"
                                            >
                                                Fora de área
                                            </rkm-form-checkbox>
                                        </rkm-input-group-text>
                                    </rkm-input-group-append>
                                </rkm-form-select>
                            </rkm-col>

                            <rkm-col cols="6">
                                <rkm-form-select
                                    :options="form.imovelTipo"
                                    textField="descricao"
                                    valueField="id"
                                    label="Tipo do imóvel"
                                    v-model="model.imovelTipoId"
                                    default-option-text="Selecione"
                                    show-default-option
                                    :validations="validations.imovelTipo"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <rkm-form-select
                                    :options="form.situacaoDomicilio"
                                    textField="descricao"
                                    valueField="id"
                                    label="Situação"
                                    v-model="model.situacaoDomicilioId"
                                    default-option-text="Selecione"
                                    show-default-option
                                    :validations="validations.situacaoDomicilio"
                                    :disabled="isDisabled()"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <rkm-form-select
                                    :options="form.zonas"
                                    textField="descricao"
                                    valueField="id"
                                    label="Zona"
                                    v-model="model.domicilioZonaId"
                                    default-option-text="Selecione"
                                    show-default-option
                                    :validations=validations.zonaDomicilio
                                    @change="handleZonaTipo"
                                    :disabled="isTipoDisabled()"
                                />
                            </rkm-col>

                           <rkm-col cols="3">
                                <rkm-form-select
                                    :options="form.domicilioTipo"
                                    textField="descricao"
                                    valueField="id"
                                    label="Tipo de domicílio"
                                    v-model="model.domicilioTipoId"
                                    default-option-text="Selecione"
                                    show-default-option
                                    :disabled="isDisabled()"
                                />
                            </rkm-col>

                            <rkm-col cols="2">
                                <rkm-form-input
                                    v-model="model.moradores"
                                    label="Moradores"
                                    number
                                    :validations="validations.moradores"
                                    disabled
                                />
                            </rkm-col>

                            <rkm-col cols="1">
                                <rkm-form-input
                                    v-model="model.quantidadeComodos"
                                    label="Cômodos"
                                    number
                                    :validations="validations.comodos"
                                    :disabled="isDisabled()"
                                />
                            </rkm-col>

                            <rkm-col cols="6">
                                <rkm-form-select
                                    :options="form.situacaoRural"
                                    textField="descricao"
                                    valueField="id"
                                    label="Situação rural"
                                    v-model="model.situacaoRuralId"
                                    default-option-text="Selecione"
                                    show-default-option
                                    :validations="validations.situacaoRural"
                                    :disabled="model.domicilioZonaId != this.enums.zonaDomicilio.RURAL
                                        || this.model.recusaCadastro"
                                />
                            </rkm-col>

                           <rkm-col cols="3">
                                <rkm-form-select
                                    :options="form.domicilioTipoAcesso"
                                    textField="descricao"
                                    valueField="id"
                                    label="Tipo de acesso ao domicílio"
                                    v-model="model.domicilioTipoAcessoId"
                                    default-option-text="Selecione"
                                    show-default-option
                                    :disabled="isDisabled()"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <rkm-form-select
                                    :options="form.materialPredominante"
                                    textField="descricao"
                                    valueField="id"
                                    label="Material predominante - paredes externas"
                                    v-model="model.materialPredominanteId"
                                    default-option-text="Selecione"
                                    show-default-option
                                    :disabled="isDisabled()"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <rkm-form-radio-group
                                    v-model="model.energiaEletrica"
                                    label="Disponibilidade de energia elétrica"
                                    :disabled="isTipoDisabled()"
                                >
                                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-col>

                            <rkm-col cols="3">
                                <rkm-form-select
                                    :options="form.abastecimento"
                                    textField="descricao"
                                    valueField="id"
                                    label="Abastecimento de água"
                                    v-model="model.abastecimentoId"
                                    default-option-text="Selecione"
                                    show-default-option
                                    :disabled="isTipoDisabled()"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <rkm-form-select
                                    :options="form.tratamento"
                                    textField="descricao"
                                    valueField="id"
                                    label="Tratamento de água"
                                    v-model="model.tratamentoId"
                                    default-option-text="Selecione"
                                    show-default-option
                                    :disabled="isTipoDisabled()"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <rkm-form-select
                                    :options="form.destinoLixo"
                                    textField="descricao"
                                    valueField="id"
                                    label="Destino do lixo"
                                    v-model="model.destinoLixoId"
                                    default-option-text="Selecione"
                                    show-default-option
                                    :disabled="isTipoDisabled()"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <rkm-form-select
                                    :options="form.formaEscoamento"
                                    textField="descricao"
                                    valueField="id"
                                    label="Forma de escoamento sanitário"
                                    v-model="model.formaEscoamentoId"
                                    default-option-text="Selecione"
                                    show-default-option
                                    :disabled="isTipoDisabled()"
                                />
                            </rkm-col>

                            <rkm-col cols="3">
                                <rkm-form-radio-group
                                    v-model="model.possuiAnimais"
                                    label="Possui animais?"
                                    :disabled="isDisabled()"
                                    @change="handleAnimais"
                                >
                                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-col>

                            <rkm-col cols="5">
                                <rkm-form-checkbox-group
                                    :options="form.animais"
                                    label="Quais"
                                    class="mx-2"
                                    name="lazer"
                                    text-field="descricao"
                                    v-model="model.animal"
                                    value-field="id"
                                    :disabled="model.imovelTipoId != this.enums.tipoImovel.DOMICILIO
                                        || !model.possuiAnimais"
                                />
                            </rkm-col>

                            <rkm-col cols="1">
                                <rkm-form-input
                                    v-model="model.quantidadeAnimais"
                                    label="Quantidade"
                                    number
                                    :validations="validations.quantidadeAnimais"
                                    :disabled="model.imovelTipoId != this.enums.tipoImovel.DOMICILIO
                                        || !model.possuiAnimais"
                                />
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>

                    <rkm-area
                        title="Informações Adicionais"
                        type="fieldset"
                    >
                        <rkm-row>

                            <rkm-col cols="6">

                                <rkm-form-select
                                    :options="form.escalaCoelho"
                                    label="Escala de coelho"
                                    show-default-option
                                    text-field="descricao"
                                    v-model="model.escalaCoelhoId"
                                    default-option-text="Selecione"
                                    value-field="id"
                                    class="pt-0"
                                />
                            </rkm-col>

                            <rkm-col cols="6">
                                <rkm-form-select
                                    :options="form.higieneResidencial"
                                    textField="descricao"
                                    valueField="id"
                                    label="Higiene residencial"
                                    v-model="model.higieneResidencialId"
                                    show-default-option
                                />
                            </rkm-col>

                            <rkm-col cols="2">
                                <rkm-form-radio-group
                                    v-model="model.bolsaFamilia"
                                    label="Bolsa família"
                                    class="pt-0"
                                >
                                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-col>

                            <rkm-col cols="2">
                                <rkm-form-radio-group
                                    v-model="model.valeGas"
                                    label="Vale gás"
                                    class="pt-0"
                                >
                                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-col>

                            <rkm-col cols="2">
                                <rkm-form-radio-group
                                    v-model="model.bolsaEscola"
                                    label="Bolsa escola"
                                    class="pt-0"
                                >
                                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-col>

                            <rkm-col cols="5">
                                <rkm-form-checkbox-group
                                    :options="form.lazer"
                                    label="Lazer"
                                    class="mx-2"
                                    name="lazer"
                                    text-field="descricao"
                                    v-model="model.lazer"
                                    value-field="id"
                                />
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>

                    <rkm-area
                        title="Outros"
                        type="fieldset"
                        v-if="!this.model.informacaoResidencialRecusaCadastro"
                    >

                        <rkm-row class="flex-nowrap">

                            <rkm-col class="flex-grow-1">

                                <rkm-form-input
                                    label="Renda mensal"
                                    ref="rendaMensal"
                                    v-model="model.rendaMensal"
                                    v-money="money"
                                    prepend="R$"
                                    :validations="validations.rendaMensal"
                                    key="rendaMensal"
                                />
                            </rkm-col>

                            <rkm-col cols="4">

                                <rkm-form-input-autocomplete
                                    label="Ocupação"
                                    :searchFields="localForm.autocompleteFields.ocupacao"
                                    :repository="repositories.ocupacao"
                                    v-model="model.ocupacao"
                                    :textField="l => `${l.codigo} - ${l.nome}`"
                                    :validations="validations.ocupacao"
                                    uppercase
                                />
                            </rkm-col>

                            <rkm-col class="flex-grow-1">
                                <rkm-form-input
                                    v-model="model.rendaTotalFamiliar"
                                    label="Renda total familiar"
                                    ref="rendaTotalFamiliar"
                                    v-money="money"
                                    prepend="R$"
                                    :validations="validations.rendaTotalFamiliar"
                                    key="rendaTotalFamiliar"
                                />
                            </rkm-col>

                            <rkm-col class="flex-grow-1">
                                <rkm-form-checkbox
                                    :value="true"
                                    v-model="model.possuiVeiculoProprio"
                                    :label="false"
                                >
                                    Possui veículo próprio
                                </rkm-form-checkbox>
                            </rkm-col>

                            <rkm-col class="flex-grow-1">
                                <rkm-form-checkbox
                                    :value="true"
                                    v-model="model.possuiFinanciamento"
                                    :label="false"
                                >
                                    Possui financiamento
                                </rkm-form-checkbox>
                            </rkm-col>

                            <rkm-col class="flex-grow-1">
                                <rkm-form-checkbox
                                    :value="true"
                                    v-model="model.possuiEmprestimo"
                                    :label="false"
                                >
                                    Possui emprestimo
                                </rkm-form-checkbox>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>

                            <rkm-col cols="12" v-if="model.possuiVeiculoProprio">

                                <rkm-area title="Veículo próprio" no-margin-top>
                                    <template
                                        slot="trailing"
                                    >
                                        <rkm-button
                                            @click="$refs.Modal.open()"
                                            color="primary"
                                            title="Adicionar veículo"
                                            small
                                        >
                                            <rkm-icon icon="plus" />
                                        </rkm-button>
                                    </template>

                                    <List
                                        :data="{ form, model }"
                                    />
                                </rkm-area>
                            </rkm-col>

                            <rkm-col cols="12" v-if="model.possuiFinanciamento">

                                <rkm-area title="Financiamento">
                                    <template
                                        slot="trailing"
                                    >
                                        <rkm-button
                                            @click="$refs.ModalFinanciamento.open()"
                                            color="primary"
                                            title="Adicionar financiamento"
                                            small
                                        >
                                            <rkm-icon icon="plus" />
                                        </rkm-button>
                                    </template>

                                    <ListFinanciamento
                                        :data="{ form, model }"
                                    />
                                </rkm-area>
                            </rkm-col>

                            <rkm-col cols="12" v-if="model.possuiEmprestimo">

                                <rkm-area title="Empréstimo">
                                    <template
                                        slot="trailing"
                                    >
                                        <rkm-button
                                            @click="$refs.ModalEmprestimo.open()"
                                            color="primary"
                                            title="Adicionar empréstimo"
                                            small
                                        >
                                            <rkm-icon icon="plus" />
                                        </rkm-button>
                                    </template>

                                    <ListEmprestimo
                                        :data="{ form, model }"
                                    />
                                </rkm-area>
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>

                    <rkm-area
                        type="fieldset"
                        title="Instituição de permanência"
                        v-if="showInstituicao"
                    >

                        <rkm-row>
                            <rkm-col cols="12">
                                <rkm-form-input
                                    v-model="model.instituicaoNome"
                                    label="Nome da instituição de permanência"
                                    :validations="validations.instituicaoNome"
                                    uppercase
                                />
                            </rkm-col>

                            <rkm-col cols="12">
                                <rkm-form-radio-group
                                    v-model="model.instituicaoOutrosProfissionais"
                                    label="Existem outros profissionais de saúde vinculados à instituição (não inclui profissionais da rede pública de saúde)?"
                                    class="pt-0"
                                >
                                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-col>

                            <rkm-col cols="12">
                                <rkm-area
                                    title="Identificação do responsável técnico da instituição de permanência"
                                    no-margin-top
                                >
                                    <rkm-row>
                                        <rkm-col cols="8">
                                            <rkm-form-input
                                                v-model="model.instituicaoNomeResponsavelTecnico"
                                                label="Responsável técnico pela instituição"
                                                :validations="validations.nomeResponsavelTecnico"
                                                uppercase
                                            />
                                        </rkm-col>
                                        <rkm-col cols="4">
                                            <rkm-form-input
                                                v-model="model.instituicaoCnsResponsavelTecnico"
                                                label="CNS do responsável"
                                                v-mask="mask.cns"
                                                :validations="validations.cnsResponsavelTecnico"
                                            />
                                        </rkm-col>
                                        <rkm-col cols="8">
                                            <rkm-form-input
                                                v-model="model.instituicaoCargoResponsavelTecnico"
                                                label="Cargo na instituição"
                                                :validations="validations.cargoResponsavelTecnico"
                                                uppercase
                                            />
                                        </rkm-col>
                                        <rkm-col cols="4">
                                            <rkm-form-input
                                                v-model="model.instituicaoTelefoneResponsavelTecnico"
                                                label="Telefone de contato"
                                                v-mask="numeroMask"
                                                :validations="validations.telefoneResponsavelTecnico"
                                            />
                                        </rkm-col>
                                    </rkm-row>
                                </rkm-area>
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>

                    <rkm-area
                        title="Recusa do Cadastro Domiciliar da Atenção Básica"
                        type="fieldset"
                        no-margin-top
                    >

                    <rkm-col cols="12">

                        <rkm-form-checkbox
                            :value="true"
                            v-model="model.informacaoResidencialRecusaCadastro"
                            @change="handleRecusaCadastro()"
                        >
                            Usuário recusou o cadastro por meio do termo de Recusa do Cadastro
                        </rkm-form-checkbox>
                    </rkm-col>
                    </rkm-area>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <Modal :data="{ form, model }" ref="Modal" />
        <ModalFinanciamento :data="{ form, model }" ref="ModalFinanciamento" />
        <ModalEmprestimo :data="{ form, model }" ref="ModalEmprestimo" />
    </div>
</template>

<script>

// Enums.
import classificacao from '@/enums/cadastro/paciente/classificacao'
import subclassificacao from '@/enums/cadastro/paciente/subclassificacao'
import permissao from '@/enums/atencao-basica/parametrizacao/permissao'
import tipoAtendimento from '@/enums/atencao-basica/atendimento-individual/tipoAtendimento'
import saidaCidadao from '@/enums/atencao-basica/saidaCidadao'

import tipoImovel from '@/enums/atencao-basica/cadastro-domiciliar/tipoImovel'
import zonaDomicilio from '@/enums/atencao-basica/cadastro-domiciliar/zonaDomicilio'

import List from './components/veiculo/List'
import Modal from './components/veiculo/Modal'
import ListFinanciamento from './components/financiamento/List'
import ModalFinanciamento from './components/financiamento/Modal'
import ListEmprestimo from './components/emprestimo/List'
import ModalEmprestimo from './components/emprestimo/Modal'

// Vuex.
import { mapGetters } from 'vuex'

// Mixins
import { repository, object, mask } from '@/mixins'

//Directives
import { VMoney } from 'v-money'

export default {
    components: { List, Modal, ListFinanciamento, ModalFinanciamento, ListEmprestimo, ModalEmprestimo },
    directives: { money: VMoney },
    mixins: [ repository, object, mask ],
    props: {
        form: { type: Object, required: true },
        model: { type: Object, required: true },
    },
    created() {
        this.repositories = {
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
            atendimentoIndividual: this.getConectaSusRepository('atencaoBasica.atendimentoIndividual'),
            cadastroIndividual: this.getConectaSusRepository('atencaoBasica.cadastroIndividual'),
            cid: this.getConectaSusRepository('sigtap.cid'),
            ocupacao: this.getConectaSusRepository('sigtap.ocupacao')
        }
    },
    data: () => ({
        enums: {
            classificacao,
            subclassificacao,
            permissao,
            tipoAtendimento,
            saidaCidadao,
            tipoImovel,
            zonaDomicilio
        },
        money: {
            decimal: ',',
            thousands: '.',
            suffix: '',
            precision: 2,
            masked: false
        },
        isRendaMensalSet: false,
        isRendaTotalFamiliarSet: false,
        unidades: [],
        equipes: [],
        infraestruturas: [],
        ocupacoes: [],
        localForm: {
            autocompleteFields: {
                ocupacao: [
                    { key: 'codigo', searchable: true },
                    { key: 'nome', searchable: true },
                ],
                comunidade: [
                    { key: 'codigoEsus', searchable: true },
                    { key: 'descricao', searchable: true },
                ],
            },
        },
    }),
    computed: {
        ...mapGetters({ cliente: 'getCliente' }),
        validations() {

            return {
                situacaoDomicilio: {
                    required: this.model.imovelTipoId == this.enums.tipoImovel.DOMICILIO
                },
                situacaoRural: {
                    required: this.model.domicilioZonaId == this.enums.zonaDomicilio.RURAL
                },
                zonaDomicilio: {
                    required: true
                },
                moradores: {
                    max: 4
                },
                comodos: {
                    max: 2
                },
                quantidadeAnimais: {
                    max: 2
                },
            }
        },
        autocompleteRequestParams() {
            return {
                usuario: {
                    with_not_regularized: true,
                    with_atencao_basica_equipe: true,
                    unidade_id: this.model.unidadeId,
                    with_atencao_basica_permissao: this.enums.permissao.CADASTRO_INDIVIDUAL,
                },
            }
        },
        fields() {
            return {
                autocomplete: {
                    usuario: [
                        { key: "cadastroCidadao.nome", searchable: true },
                        { key: "cadastroUsuario.registroNumero", searchable: true },
                    ],
                    cid: [{ key: "nome", searchable: true }],
                    obito: {
                        cid: [
                            { key: 'codigo', searchable: true },
                            { key: 'nome', searchable: true },
                        ],
                    },
                },
            }
        },
        numeroMask() {

            if (this.model.instituicaoTelefoneResponsavelTecnico === '') {
                return ''
            }

            return this.model.instituicaoTelefoneResponsavelTecnico
                && this.model.instituicaoTelefoneResponsavelTecnico.length < 15
                ? this.mask.phone
                : this.mask.cellPhone
        },
        showInstituicao() {

            if(this.model && !this.model.informacaoResidencialRecusaCadastro) {

                const imovelTipoId = this.model.imovelTipoId
                const tiposImovel = [
                    this.enums.tipoImovel.ABRIGO,
                    this.enums.tipoImovel.INSTITUICAO_DE_LONGA_PERMANENCIA_PARA_IDOSOS,
                    this.enums.tipoImovel.UNIDADE_PRISIONAL,
                    this.enums.tipoImovel.UNIDADE_DE_MEDIDA_SOCIO_EDUCATIVA,
                    this.enums.tipoImovel.DELEGACIA
                ]

                return tiposImovel.includes(imovelTipoId) ? true : false;
            } else {

                return false
            }
        },
    },
    watch: {
        'model.rendaMensal': function (rendaMensal) {

            if (parseInt(rendaMensal) > 0 && !this.isRendaMensalSet) {

                this.isRendaMensalSet = true
                this.$refs.rendaMensal.$el.getElementsByTagName('input')[0].value = rendaMensal
            }
        },
        'model.rendaTotalFamiliar': function (rendaTotalFamiliar) {

            if (parseInt(rendaTotalFamiliar) > 0 && !this.isRendaTotalFamiliarSet) {

                this.isRendaTotalFamiliarSet = true
                this.$refs.rendaTotalFamiliar.$el.getElementsByTagName('input')[0].value = rendaTotalFamiliar
            }
        },
    },
    methods: {
        validate() {

            return this.$refs.Form.validate()
        },
        getMessageClassificacao(id) {

            let message = ''

            switch (id) {

                case this.enums.classificacao.MUNICIPE: {

                    message = `${this.cliente.municipio.nome} com comprovação de endereço`

                    break;
                }
                case this.enums.classificacao.PROVISORIO: {

                    message = `${this.cliente.municipio.nome} sem comprovação de endereço`

                    break;
                }
                case this.enums.classificacao.OUTRO_MUNICIPIO: {

                    message = 'outro município'

                    break;
                }
            }

            return `Este paciente reside em ${message}. Confirma o cadastro?`
        },
        handleSubclassificacaoChange() {

            this.model.periodoValidade.start = null
            this.model.periodoValidade.end = null
        },
        handleResponsavel() {

            if (this.model.responsavel) {

                this.model.responsavelCidadaoId = null
            } else {

                this.model.responsavelCidadaoId = this.form.responsaveis && this.form.responsaveis.length == 1
                    ? this.form.responsaveis[0].id : null
            }
        },
        resetComunidadeTradicionalQual() {

            if (!this.model.comunidadeTradicional) {
                this.model.comunidadeTradicionalQual = null
            }
        },
        hasLogradouro() {

            return this.model.logradouro ? false : true
        },
        handleZonaTipo() {

            if (this.model.domicilioZonaId != this.enums.zonaDomicilio.RURAL) {
                this.model.situacaoRuralId = null
            }
        },
        handleAnimais() {

            if (!this.model.possuiAnimais) {
                this.model.animais = []
                this.model.quantidadeAnimais = ''
            }
            },
            isDisabled() {

            return this.model.imovelTipoId != this.enums.tipoImovel.DOMICILIO
                || this.model.recusaCadastro
        },
        isTipoDisabled() {

            const recusa = this.model.recusaCadastro
            const imovelTipoId = this.model.imovelTipoId
            const tiposImovel = [
                this.enums.tipoImovel.ABRIGO,
                this.enums.tipoImovel.DOMICILIO,
                this.enums.tipoImovel.INSTITUICAO_DE_LONGA_PERMANENCIA_PARA_IDOSOS,
                this.enums.tipoImovel.UNIDADE_PRISIONAL,
                this.enums.tipoImovel.UNIDADE_DE_MEDIDA_SOCIO_EDUCATIVA,
                this.enums.tipoImovel.DELEGACIA
            ]

            return !recusa && tiposImovel.includes(imovelTipoId) ? false : true
        },
        handleRecusaCadastro() {
            if (this.model.informacaoResidencialRecusaCadastro) {

                this.showConfirmation(
                    'Ao marcar que o usuário recusou o cadastro, todas as informações na seção Outros serão apagadas. Deseja continuar?',
                    async () => this.reset(),
                    async () => this.cancel()
                )
            }
        },
        reset() {

            this.model.rendaMensal = null
            this.model.ocupacao = null
            this.model.rendaTotalFamiliar = null
            this.model.possuiEmprestimo = null
            this.model.possuiVeiculoProprio = null
            this.model.possuiFinanciamento = null
            this.model.veiculos = []
            this.model.financiamentos = []
            this.model.emprestimos = []
        },
        cancel() {

            this.model.informacaoResidencialRecusaCadastro = false
        },
    }
}
</script>